module.exports = __webpack_public_path__ + "media/images/emblems/Villars-sur-Glane-coat_of_arms-94b2ce28119eb33963a8d093d8673794.svg";